import React from "react";
import ThemedButton from "../../components/ui/ThemeButton";

export interface HeroProps {
  hero?: {
    title?: string;
    tagline?: string;
    ctaText?: string;
    coverImage?: string;
  };
  themeColor: string;
}

const MicrositeHeroSection: React.FC<HeroProps> = ({ hero = {}, themeColor="#885ABB" }) => {

  const bg =hero.coverImage;
  const title = hero.title;
  const desc = hero.tagline;
  const cta = hero.ctaText;

  const scrollToContact = () => {
    const element = document.getElementById("contact");
    if (element) {
      const offset = 80;
      const position =
        element.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: position, behavior: "smooth" });
    }
  };

  return (
    <div className="relative h-[100vh] flex flex-col justify-center items-center text-center font-serif overflow-hidden">
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center brightness-75"
        style={{ backgroundImage: `url(${bg})` }}
      ></div>

      {/* Overlay gradient */}
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>

      {/* Content */}
      <div className="relative z-10 flex flex-col justify-center items-center px-6">
        <h1 className="text-6xl md:text-7xl text-white mb-6 drop-shadow-md">
          {title}.
        </h1>
        <p className="text-2xl text-white font-light tracking-wide mb-8 drop-shadow-md break-words max-w-lg">
          {desc}.
        </p>

        {/* CTA Button */}
        <ThemedButton
          themeColor={themeColor}
          onClick={scrollToContact}
        >
          {cta}
        </ThemedButton>
      </div>
    </div>
  );
};

export default MicrositeHeroSection;
